
import React from 'react';
import { Activity } from 'lucide-react';
import { CardHeader, CardTitle } from '@/components/ui/card';
import { getBloodSugarStatus } from '@/utils/bloodSugarCalculation';

interface BloodSugarHeaderProps {
  currentValue: number;
}

export const BloodSugarHeader: React.FC<BloodSugarHeaderProps> = ({ currentValue }) => {
  const { text, color } = getBloodSugarStatus(currentValue);
  
  return (
    <CardHeader className="pb-1">
      <CardTitle className="flex items-center justify-between text-fasttrack-blue text-base">
        <div className="flex items-center">
          <Activity className="mr-2" /> Blood Sugar Estimate
        </div>
        <div className="flex items-center">
          <span className={`text-lg font-bold ${color}`}>{currentValue}</span>
          <span className="text-xs text-muted-foreground ml-1">mg/dL</span>
        </div>
      </CardTitle>
      <p className={`text-xs ${color}`}>{text}</p>
    </CardHeader>
  );
};
